// 退出确认对话框组件
import { useApp } from '../context/AppContext'

export default function ExitConfirmDialog() {
  const { exitConfirm, setExitConfirm, showToast } = useApp()

  if (!exitConfirm) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.2s ease-out'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '24px',
        width: '280px',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        animation: 'slideUp 0.3s ease-out'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#FFF3E0',
          margin: '0 auto 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <i className="fa-solid fa-door-open" style={{ fontSize: '28px', color: '#FF9800' }}></i>
        </div>
        
        <h3 style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '8px'
        }}>
          确定要退出吗？
        </h3>
        
        <p style={{
          fontSize: '14px',
          color: '#666',
          marginBottom: '20px',
          lineHeight: '1.5'
        }}>
          您的学习进度已保存
        </p>
        
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>
          <button
            onClick={() => setExitConfirm()}
            style={{
              flex: 1,
              padding: '12px 16px',
              borderRadius: '24px',
              border: '2px solid #6C63FF',
              backgroundColor: 'white',
              color: '#6C63FF',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            继续学习
          </button>
          
          <button
            onClick={() => {
              // 实际退出应用
              try {
                // 方案1: 使用 Capacitor App 插件
                if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.App) {
                  window.Capacitor.Plugins.App.exitApp()
                }
                // 方案2: 使用 Android 原生接口
                else if (window.AndroidBackHandler && window.AndroidBackHandler.exitApp) {
                  window.AndroidBackHandler.exitApp()
                }
                // 方案3: 备用
                else if (window.AndroidBridge && window.AndroidBridge.exit) {
                  window.AndroidBridge.exit()
                }
                // Web 环境提示
                else {
                  showToast('在APP中点击返回键两次退出')
                  setExitConfirm()
                }
              } catch (e) {
                console.error('Exit failed:', e)
                // 最后方案：使用 Android 接口
                if (window.AndroidBackHandler && window.AndroidBackHandler.exitApp) {
                  window.AndroidBackHandler.exitApp()
                } else {
                  showToast('退出失败，请手动返回')
                  setExitConfirm()
                }
              }
            }}
            style={{
              flex: 1,
              padding: '12px 16px',
              borderRadius: '24px',
              border: 'none',
              backgroundColor: '#6C63FF',
              color: 'white',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            确定退出
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(20px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  )
}
